import {
  CREATE_SKU_IDENTIFIER,
  CREATE_SKU_IDENTIFIER_SUCCESS,
  DELETE,
  DELETE_SKU,
  DELETE_SUCCESS,
  GET_ALL,
  GET_ALL_SUCCESS,
  GET_BUSINESSES_SUCCESS,
  GET_DETAIL,
  GET_DETAIL_SUCCESS,
  GET_INTEGRATION_SUCCESS,
  GET_PRODUCT_PACK_TYPE_SUCCESS,
  GET_PRODUCT_SKU_FILE_SUB_TYPES_SUCCESS,
  GET_PRODUCT_TYPES_SUCCESS,
  REMOVE_SKU_IDENTIFIER,
  REMOVE_SKU_IDENTIFIER_SUCCESS,
  REQUEST_ERROR,
  SORTABLE_SKU,
  UPDATE,
  UPDATE_SKU,
  UPDATE_SKU_FILES,
  UPDATE_SKU_FILES_SUCCESS,
  UPDATE_SKU_IDENTIFIER,
  UPDATE_SKU_IDENTIFIER_SUCCESS,
  UPDATE_SKU_SUCCESS,
  UPDATE_SUCCESS,
} from '../types/product';
import { updateStates } from '@/utils/reducer';

const initState = {
  isLoading: false,
  isUpdating: false,
  items: [],
  metadata: {},
  product: {},
  error: '',
  integrations: [],
  businessIds: [],
  types: [],
  skuProductFileSubTypes: [],
  packType: [],
};

const reducer = (state = initState, action) => {
  const { type, data } = action;
  switch (type) {
    case GET_ALL:
    case GET_DETAIL:
    case DELETE:
      return updateStates(state, {
        isLoading: action?.isLoading !== undefined ? action?.isLoading : true,
        isUpdating: action?.isUpdating !== undefined ? action?.isUpdating : true,
      });
    case UPDATE_SKU:
    case UPDATE_SKU_FILES:
    case CREATE_SKU_IDENTIFIER:
    case REMOVE_SKU_IDENTIFIER:
    case UPDATE_SKU_IDENTIFIER:
    case DELETE_SKU:
    case UPDATE:
      return updateStates(state, {
        isUpdating: true,
      });

    case GET_ALL_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        items: [...data.data],
        metadata: { ...data.metadata },
      });
    case GET_DETAIL_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        isUpdating: false,
        product: { ...data },
      });
    case UPDATE_SKU_FILES_SUCCESS: {
      const product_skus = state.product.product_skus;
      const index = product_skus.findIndex((_) => _.id === action.payload.skuId);
      product_skus[index].files = action.payload.data;
      return updateStates(state, {
        product: { ...state.product, product_skus },
        isUpdating: false,
      });
    }
    case UPDATE_SKU_IDENTIFIER_SUCCESS:
    case UPDATE_SUCCESS:
      return updateStates(state, {
        isUpdating: false,
      });
    case DELETE_SUCCESS:
      return updateStates(state, {
        product: {},
        isLoading: false,
      });
    case CREATE_SKU_IDENTIFIER_SUCCESS: {
      const product_skus = state.product.product_skus;
      const index = product_skus.findIndex((_) => _.id === action.payload.skuId);
      product_skus[index].identifiers = [
        ...state.product.product_skus[index].identifiers,
        action.payload.data,
      ];
      return updateStates(state, {
        product: { ...state.product, product_skus },
        isUpdating: false,
      });
    }
    case REMOVE_SKU_IDENTIFIER_SUCCESS: {
      const product_skus = state.product.product_skus;
      const index = product_skus.findIndex((_) => _.id === action.payload.skuId);
      product_skus[index].identifiers = state.product.product_skus[index].identifiers.filter(
        (_) => _.id !== action.payload.id,
      );

      return updateStates(state, {
        product: { ...state.product, product_skus },
        isUpdating: false,
      });
    }
    case UPDATE_SKU_SUCCESS: {
      const product_skus = state.product.product_skus;
      const { identifiers, files, ...rest } = action.payload.data;
      const index = product_skus.findIndex((_) => _.id === action.payload.skuId);
      product_skus[index] = { ...state.product.product_skus[index], ...rest };

      return updateStates(state, {
        product: { ...state.product, product_skus },
        isUpdating: false,
      });
    }
    case REQUEST_ERROR:
    case SORTABLE_SKU:
      return updateStates(state, {
        isLoading: false,
        isUpdating: false,
      });
    case GET_INTEGRATION_SUCCESS:
      return updateStates(state, {
        integrations: action.data,
      });
    case GET_BUSINESSES_SUCCESS:
      return updateStates(state, {
        businessIds: action.data,
      });
    case GET_PRODUCT_TYPES_SUCCESS:
      return updateStates(state, { types: action.payload });
    case GET_PRODUCT_SKU_FILE_SUB_TYPES_SUCCESS:
      return updateStates(state, { skuProductFileSubTypes: action.payload });
    case GET_PRODUCT_PACK_TYPE_SUCCESS:
      return updateStates(state, {
        packType: action.payload,
      });
    default:
      return state;
  }
};

export default reducer;
